import React from "react";
import { Wrapper, ButtonsContainer, Header } from "./style";
import { Button } from "../../../common/Button";

type ConfirmDeletionProps = {
    onCancel: () => void;
    onDelete: () => void;
}

export default function ConfirmPaylinkDeletion({ onCancel, onDelete }: ConfirmDeletionProps) {
    return (
        <Wrapper>
            <div>
                <Header>Delete payment link</Header>
                <p>Are you sure you want to delete this payment link?</p>
            </div>

            <ButtonsContainer>
                <Button
                    theme='alternate'
                    label='Cancel'
                    height='40px'
                    fontSize='12px'
                    onClick={onCancel}
                />
                <Button
                    theme='secondary'
                    label='Delete'
                    height='40px'
                    fontSize='12px'
                    onClick={onDelete}
                />
            </ButtonsContainer>
        </Wrapper>
    )
}